import * as api from '@owl-nest/api-client/next'
import * as hooks from '@owl-nest/hooks'

import * as base from './base'

export type ShippingZoneHelpers = {
  createShippingZone(payload: api.CreateShippingZone): Promise<api.HttpResult<api.ShippingZones>>
  updateShippingZone(
    shippingZoneId: number,
    payload: api.UpdateShippingZone,
  ): Promise<api.HttpResult<api.ShippingZones>>
  deleteShippingZone(shippingZoneId: number): Promise<api.HttpResult<void>>
}

export function shippingZoneHelpers(
  slugOrId: string | number,
  sharedQuery: hooks.SharedQueryHelper<api.Project<''>, [slugOrId: string | number]>,
): ShippingZoneHelpers {
  return { createShippingZone, updateShippingZone, deleteShippingZone }

  async function createShippingZone(payload: api.CreateShippingZone): Promise<api.HttpResult<api.ShippingZones>> {
    const result = await base.createShippingZone(slugOrId, payload)

    return result.nextAsync(async (zones) => {
      await sharedQuery.query(slugOrId)
      return zones
    })
  }

  async function updateShippingZone(
    shippingZoneId: number,
    payload: api.UpdateShippingZone,
  ): Promise<api.HttpResult<api.ShippingZones>> {
    const result = await base.updateShippingZone(shippingZoneId, payload)

    return result.nextAsync(async (zones) => {
      await sharedQuery.query(slugOrId)
      return zones
    })
  }

  async function deleteShippingZone(shippingZoneId: number): Promise<api.HttpResult<void>> {
    const result = await base.deleteShippingZone(shippingZoneId)

    return result.nextAsync(async () => {
      await sharedQuery.query(slugOrId)
    })
  }
}
